import { render, staticRenderFns } from "./CommentDropDown.vue?vue&type=template&id=75a50cb1"
import script from "./CommentDropDown.vue?vue&type=script&lang=js"
export * from "./CommentDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports